export function ArrowRight({ className }: { className?: string }) {
  return (
    <svg
      width="17"
      height="11"
      viewBox="0 0 16.53 10.9914"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="M15.53 6.49139H1C0.45 6.49139 0 6.04139 0 5.49139C0 4.94139 0.45 4.49139 1 4.49139H15.53C16.08 4.49139 16.53 4.94139 16.53 5.49139C16.53 6.04139 16.08 6.49139 15.53 6.49139Z" />
      <path d="M15.53 6.49139C15.3 6.49139 15.08 6.41139 14.89 6.26139L9.47999 1.77139C9.05999 1.42139 8.99999 0.79139 9.34999 0.36139C9.69999 -0.0686096 10.33 -0.11861 10.76 0.23139L16.17 4.72139C16.59 5.07139 16.65 5.70139 16.3 6.13139C16.1 6.37139 15.82 6.49139 15.53 6.49139Z" />
      <path d="M10.12 10.9914C9.82999 10.9914 9.54999 10.8714 9.34999 10.6314C8.99999 10.2114 9.05999 9.57139 9.47999 9.22139L14.89 4.73139C15.31 4.38139 15.95 4.43139 16.3 4.86139C16.65 5.28139 16.59 5.92139 16.17 6.27139L10.76 10.7614C10.57 10.9214 10.35 10.9914 10.12 10.9914Z" />
    </svg>
  );
}

export function Chevron({ dir, className }: { dir: "left" | "right"; className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
      <path
        d={dir === "left" ? "M12.5 15L7.5 10L12.5 5" : "M7.5 15L12.5 10L7.5 5"}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CheckRing({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 13.3333 13.3333"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="M5.73333 9.73333L10.4333 5.03333L9.5 4.1L5.73333 7.86667L3.83333 5.96667L2.9 6.9L5.73333 9.73333V9.73333M6.66667 13.3333C5.74444 13.3333 4.87778 13.1583 4.06667 12.8083C3.25556 12.4583 2.55 11.9833 1.95 11.3833C1.35 10.7833 0.875 10.0778 0.525 9.26667C0.175 8.45556 0 7.58889 0 6.66667C0 5.74444 0.175 4.87778 0.525 4.06667C0.875 3.25556 1.35 2.55 1.95 1.95C2.55 1.35 3.25556 0.875 4.06667 0.525C4.87778 0.175 5.74444 0 6.66667 0C7.58889 0 8.45556 0.175 9.26667 0.525C10.0778 0.875 10.7833 1.35 11.3833 1.95C11.9833 2.55 12.4583 3.25556 12.8083 4.06667C13.1583 4.87778 13.3333 5.74444 13.3333 6.66667C13.3333 7.58889 13.1583 8.45556 12.8083 9.26667C12.4583 10.0778 11.9833 10.7833 11.3833 11.3833C10.7833 11.9833 10.0778 12.4583 9.26667 12.8083C8.45556 13.1583 7.58889 13.3333 6.66667 13.3333V13.3333M6.66667 12C8.15556 12 9.41667 11.4833 10.45 10.45C11.4833 9.41667 12 8.15556 12 6.66667C12 5.17778 11.4833 3.91667 10.45 2.88333C9.41667 1.85 8.15556 1.33333 6.66667 1.33333C5.17778 1.33333 3.91667 1.85 2.88333 2.88333C1.85 3.91667 1.33333 5.17778 1.33333 6.66667C1.33333 8.15556 1.85 9.41667 2.88333 10.45C3.91667 11.4833 5.17778 12 6.66667 12V12Z" />
    </svg>
  );
}

export function CheckCircle({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0A12 12 0 1 0 12 24A12 12 0 1 0 12 0ZM5.98 13.07L9.33 16.42A1.3 1.3 0 0 0 11.17 16.42L18.02 9.57A1.3 1.3 0 0 0 16.18 7.73L10.25 13.66L7.82 11.23A1.3 1.3 0 0 0 5.98 13.07Z"
      />
    </svg>
  );
}

export function DisclosureChevron({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
      <path
        d="M7 4L13 10L7 16"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
